wrapPromiseWithState